<template>
  <thead class="bg-gray-50">
    <tr>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-full align-bottom"
      >
        {{ $t('global.name') }}
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider align-bottom"
      >
        Impressions
        <template v-if="$isAdminOrSuperAdmin">
          <br />
          (cpm)
        </template>
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider align-bottom"
      >
        Reach
        <template v-if="$isAdminOrSuperAdmin">
          <br />
          (cpr)
        </template>
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider align-bottom"
      >
        Pageviews
        <template v-if="$isAdminOrSuperAdmin">
          <br />
          (ppi / cpp)
        </template>
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider align-bottom"
      >
        Contact requests
        <template v-if="$isAdminOrSuperAdmin">
          <br />
          (cpcr)
        </template>
      </th>
      <th
        v-if="$isAdminOrSuperAdmin"
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider align-bottom"
      >
        Spend
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider align-bottom"
      >
        {{ $t('global.created') }}
      </th>
    </tr>
  </thead>
</template>

<script>
export default {};
</script>
